import React, { useState } from "react";
import { useForm } from "react-hook-form";

const Contact = ({ onSubmit }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm();
  const [status, setStatus] = useState(null);

  const submit = async (data) => {
    setStatus(null);
    try {
      const response = await fetch("send_mail.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(data),
      });
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
      setStatus({ type: "success", text: "ההודעה נשלחה בהצלחה. ניצור איתך קשר בהקדם." });
      reset();
      if (onSubmit) {
        setTimeout(onSubmit, 1500);
      }
    } catch (error) {
      setStatus({
        type: "error",
        text: "אירעה שגיאה בשליחת ההודעה. אנא נסו שוב או התקשרו אלינו ישירות.",
      });
    }
  };

  return (
    <form className="contact_form" onSubmit={handleSubmit(submit)} noValidate>
      <div className="first">
        <ul>
          <li>
            <input
              {...register("name", { required: true })}
              type="text"
              placeholder="שם"
              aria-invalid={errors.name ? "true" : "false"}
            />
            {errors.name && <span role="alert">אנא הזן שם</span>}
          </li>

          <li>
            <input
              {...register("email", {
                required: "אנא הזן כתובת דוא״ל",
                pattern: {
                  value: /\S+@\S+\.\S+/,
                  message: "כתובת הדוא״ל שהוזנה אינה תקינה",
                },
              })}
              type="email"
              placeholder="דוא״ל"
              aria-invalid={errors.email ? "true" : "false"}
            />
            {errors.email && <span role="alert">{errors.email.message}</span>}
          </li>

          <li>
            <textarea
              {...register("message", { required: true })}
              placeholder="הודעה"
              aria-invalid={errors.message ? "true" : "false"}
            ></textarea>
            {errors.message && <span role="alert">אנא הזן הודעה</span>}
          </li>
        </ul>
      </div>

      <div className="tokyo_tm_button">
        <button
          type="submit"
          className="white-fill-bg fill-black"
          disabled={isSubmitting}
        >
          {isSubmitting ? "שולח..." : "שלח"}
        </button>
      </div>

      {status && (
        <p className={`form_status form_status--${status.type}`} role="status">
          {status.text}
        </p>
      )}
    </form>
  );
};

export default Contact;
